function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.123,
    height: 24,
    viewBox: "0 0 25.123 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.056 28.918a2.063 2.063 0 0 0 1.4-.737l4.18-3.781 7.418.011c3.414 0 5.331-1.974 5.331-5.342V10.26c0-3.369-1.917-5.342-5.331-5.342H9.593c-3.4 0-5.331 1.974-5.331 5.342v8.813c0 3.38 1.985 5.331 5.251 5.331h.454v3.289c0 .749.397 1.225 1.089 1.225zm-.227-17.342a.737.737 0 0 1 0-1.474H22.7a.737.737 0 1 1 0 1.474zm0 3.754a.746.746 0 0 1-.726-.76.738.738 0 0 1 .726-.726H22.7a.733.733 0 0 1 .737.726.748.748 0 0 1-.737.76zm0 3.743a.743.743 0 0 1 0-1.486h7.747a.743.743 0 0 1 0 1.486z",
    transform: "translate(-4.262 -4.918)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.d3acf64a.svg";
export { ForwardRef as ReactComponent };